// extracted by mini-css-extract-plugin
module.exports = {"dots-container":"action-menu__dots-container___hTjvJ","dot":"action-menu__dot___1PGhQ","dot--small":"action-menu__dot--small___1toD9 action-menu__dot___1PGhQ"};